export const generateOrganizationTemplateText = (
  inn: string | undefined,
  ogrn: string | undefined,
  organizationName: string | undefined,
  rafpNza: string | undefined,
) => {
  const textArray: Array<string> = [];

  if (inn) {
    textArray.push(`ИНН: ${inn}`);
  }
  if (ogrn) {
    textArray.push(`ОГРН: ${ogrn}`);
  }
  if (organizationName) {
    textArray.push(`Наименование: ${organizationName}`);
  }
  if (rafpNza) {
    textArray.push(`РАФП: ${rafpNza}`);
  }

  return textArray.join(', ');
};
